import React from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { PICTURE_URL } from "../../api/BaseConfig";
import { SliderDelete } from "../../Redux/Actions/SliderAction";
import { Checkbox } from "@chakra-ui/react";

const Slider = (props) => {
  const { slider } = props;
  console.log(slider)

  const dispatch = useDispatch();

  const deleteHandler = (lang, id) => {
    let result = window.confirm("Are you sure?");
    if (result) {
      dispatch(SliderDelete(lang, id));
    }
  };
  const removeHtmlTags = (str) => {
    if (!str) return "";
    const text = str.replace(/<[^>]*>/g, "");
    const textArea = document.createElement("textarea");
    textArea.innerHTML = text;
    return textArea.value;
  };
  return (
    <>
      <div className="col-md-6 col-sm-6 col-lg-4 mb-5">
        <div className="card card-product-grid shadow-sm">
          <Link to="#" className="img-wrap">
            <img src={PICTURE_URL + slider.photoUrl} alt="Slider" className="w-full" />
          </Link>
          <div className="info-wrap">
            <div className="title text-truncate font-weight-bold text-dark" style={{ fontSize: "1.25rem" }}>
              {slider?.sliderRecord[0]?.name}
            </div>
            <div className="date mb-3 text-truncate text-muted" style={{ fontStyle: "italic", fontSize: "1rem" }}>
              {removeHtmlTags(slider?.sliderRecord[0]?.description)}
            </div>
            <div>
              <div style={{
                color: slider?.status ? 'green' : 'red',
                fontWeight: 'bold',
                fontSize: '1.1rem',
                display: 'flex',
                alignItems: 'center'
              }}>
                <Checkbox
                  size="lg"
                  isChecked={slider?.status}
                  colorScheme={slider?.status ? "green" : "red"}
                  borderColor={slider?.status ? "green.500" : "red.500"}
                  isReadOnly
                />
                <span style={{ marginLeft: '10px' }}>
                  {slider?.status ? "Aktivdir" : "Aktiv deyil"}
                </span>
              </div>

            </div>
            <div className="row m-2">
              <Link
                to={`/slider/${slider.id}/edit`}
                className="btn btn-sm btn-outline-success p-2 pb-3 col-md-6"
              >
                <i className="fas fa-pen"></i>
              </Link>
              <Link
                to="#"
                onClick={() => deleteHandler(slider.id)}
                className="btn btn-sm btn-outline-danger p-2 pb-3 col-md-6"
              >
                <i className="fas fa-trash-alt"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Slider;
